import { render, staticRenderFns } from "./Flyer.vue?vue&type=template&id=a6453704&scoped=true&"
import script from "./Flyer.vue?vue&type=script&lang=js&"
export * from "./Flyer.vue?vue&type=script&lang=js&"
import style0 from "./Flyer.vue?vue&type=style&index=0&id=a6453704&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6453704",
  null
  
)

export default component.exports